import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../config";
import "../styles/Vendors.css"; // connected vendors css

export default function Vendors() {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [createModal, setCreateModal] = useState(false);
  const [formData, setFormData] = useState({
    vendorId: "",
    vendorName: "",
    email: "",
    contact: "",
    address: "",
    vendorType: "", // NEW COLUMN
  });

  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({
    vendorId: "",
    vendorName: "",
    email: "",
    contact: "",
    address: "",
    vendorType: "",
  });

  // Fetch vendors
  const fetchVendors = async () => {
    try {
      const res = await axios.get(`${config.baseUrl}/api/vendors`);
      setVendors(res.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch vendors");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  // Create input change
  const handleCreateChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Edit input change
  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  // Create Vendor
  const createVendor = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${config.baseUrl}/api/vendors`, formData);

      alert("Vendor created successfully!");
      setCreateModal(false);

      setFormData({
        vendorId: "",
        vendorName: "",
        email: "",
        contact: "",
        address: "",
        vendorType: "",
      });

      fetchVendors();
    } catch (err) {
      console.error(err);
      alert("Failed to create vendor");
    }
  };

  // Open Edit Modal
  const openEditModal = (vendor) => {
    setEditData(vendor);
    setEditModal(true);
  };

  // Update Vendor
  const updateVendor = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${config.baseUrl}/api/vendors/${editData.vendorId}`,
        editData
      );

      alert("Vendor updated successfully!");
      setEditModal(false);
      fetchVendors();
    } catch (err) {
      console.error(err);
      alert("Failed to update vendor");
    }
  };

  return (
    <div className="vendors-container">
      <div className="header-row">
        <h2 className="vendors-title">Vendors Management</h2>
        <button className="create-btn" onClick={() => setCreateModal(true)}>
          + Add Vendor
        </button>
      </div>

      <p className="vendors-subtitle">Manage vendor accounts and details</p>

      {loading && <p>Loading vendors...</p>}
      {error && <p className="error">{error}</p>}

      {/* Table */}
      {!loading && !error && (
        <div className="table-wrapper">
          <table className="vendors-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Vendor Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Address</th>
                <th>Vendor Type</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {vendors.map((v) => (
                <tr key={v.vendorId}>
                  <td>{v.vendorId}</td>
                  <td>{v.vendorName}</td>
                  <td>{v.email}</td>
                  <td>{v.contact}</td>
                  <td>{v.address}</td>
                  <td>{v.vendorType || "N/A"}</td>
                  <td>
                    <button className="edit-btn" onClick={() => openEditModal(v)}>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* CREATE MODAL */}
      {createModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Add New Vendor</h3>

            <form onSubmit={createVendor}>
              <input
                type="number"
                name="vendorId"
                placeholder="Vendor ID"
                value={formData.vendorId}
                onChange={handleCreateChange}
                required
              />

              <input
                type="text"
                name="vendorName"
                placeholder="Vendor Name"
                value={formData.vendorName}
                onChange={handleCreateChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleCreateChange}
                required
              />

              <input
                type="text"
                name="contact"
                placeholder="Contact"
                value={formData.contact}
                onChange={handleCreateChange}
                required
              />

              <textarea
                name="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleCreateChange}
                required
              ></textarea>

              <input
                type="text"
                name="vendorType"
                placeholder="Vendor Type"
                value={formData.vendorType}
                onChange={handleCreateChange}
              />

              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setCreateModal(false)}
                >
                  Cancel
                </button>
                <button className="save-btn" type="submit">
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {editModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Edit Vendor</h3>

            <form onSubmit={updateVendor}>
              <input type="number" name="vendorId" value={editData.vendorId} disabled />

              <input
                type="text"
                name="vendorName"
                value={editData.vendorName}
                onChange={handleEditChange}
                required
              />

              <input
                type="email"
                name="email"
                value={editData.email}
                onChange={handleEditChange}
                required
              />

              <input
                type="text"
                name="contact"
                value={editData.contact}
                onChange={handleEditChange}
                required
              />

              <textarea
                name="address"
                value={editData.address}
                onChange={handleEditChange}
                required
              ></textarea>

              <input
                type="text"
                name="vendorType"
                placeholder="Vendor Type"
                value={editData.vendorType}
                onChange={handleEditChange}
              />

              <div className="modal-actions">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setEditModal(false)}
                >
                  Cancel
                </button>

                <button className="save-btn" type="submit">
                  Update Vendor
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
